/* eslint-disable react-refresh/only-export-components */

import classNames from "classnames";
import * as React from "react";

import { arrow_down_small } from "./data/arrow_down_small";
import { arrow_left_small } from "./data/arrow_left_small";
import { arrow_long_right_small } from "./data/arrow_long_right_small";
import { arrow_right_small } from "./data/arrow_right_small";
import { arrow_up_small } from "./data/arrow_up_small";
import { arrows_circle_small } from "./data/arrows_circle_small";
import { arrows_up_down_small } from "./data/arrows_up_down_small";
import { book_info } from "./data/book_info";
import { book_section_mark_small } from "./data/book_section_mark_small";
import { browser_small } from "./data/browser_small";
import { calendar_small } from "./data/calendar_small";
import { ChevronDown } from "./data/chevron-down-small";
import { ChevronLeft } from "./data/chevron-left-small";
import { ChevronRight } from "./data/chevron-right-small";
import { ChevronSmallDown } from "./data/chevron-small-down-small";
import { ChevronSmallLeft } from "./data/chevron-small-left-small";
import { ChevronSmallRight } from "./data/chevron-small-right-small";
import { ChevronSmallUp } from "./data/chevron-small-up-small";
import { ChevronUp } from "./data/chevron-up-small";
import { Circle } from "./data/Circle";
import { circle_information_small } from "./data/circle_information_small";
import { circle_question_mark_small } from "./data/circle_question_mark_small";
import { clock_small } from "./data/clock_small";
import { cross_104_small } from "./data/cross_104_small";
import { document_standard_small } from "./data/document_standard_small";
import { documentadd } from "./data/documentadd";
import { documentcheck } from "./data/documentcheck";
import { Dot } from "./data/Dot";
import { drag_small } from "./data/drag_small";
import { envelope_small } from "./data/envelope_small";
import { exit_small } from "./data/exit_small";
import { external_link } from "./data/external_link";
import { eye } from "./data/eye";
import { face_sad_small } from "./data/face_sad_small";
import { face_smiling_small } from "./data/face_smiling_small";
import { filter } from "./data/filter";
import { filter_settings } from "./data/filter_settings";
import { filter_x } from "./data/filter_x";
import { folderplus } from "./data/folder_plus";
import { gears_small } from "./data/gears_small";
import { globe_small } from "./data/globe_small";
import { hamburger_menu_small } from "./data/hamburger_menu_small";
import { hand_sbb_297_small } from "./data/hand_sbb_297_small";
import { house } from "./data/house";
import { information_small } from "./data/information_small";
import { link } from "./data/link";
import { list_small } from "./data/list_small";
import { magnifying_glass_small } from "./data/magnifying_glass_small";
import { network_small } from "./data/network_small";
import { nine_squares_small } from "./data/nine_squares_small";
import { openfolder } from "./data/openfolder";
import { paragraph_small } from "./data/paragraph_small";
import { pen_16_small } from "./data/pen_16_small";
import { plus_small } from "./data/plus_small";
import { powerpoint } from "./data/powerpoint";
import { save } from "./data/save";
import { sbb_icon } from "./data/sbb_icon";
import { sbb_icon_intranet } from "./data/sbb_icon_intranet";
import { sbb_icon_logo } from "./data/sbb_icon_logo";
import { search } from "./data/search";
import { sign_exclamation_point_1_small } from "./data/sign_exclamation_point_1_small";
import { sign_exclamation_point_small } from "./data/sign_exclamation_point_small";
import { speech_bubble_group_empty_small } from "./data/speech_bubble_group_empty_small";
import { speech_bubble_small } from "./data/speech_bubble_small";
import { star } from "./data/star";
import { telephone_receiver_small } from "./data/telephone_receiver_small";
import { tick_112_small } from "./data/tick_112_small";
import { trash_8_small } from "./data/trash_8_small";
import { two_speeching_bubbles } from "./data/two_speeching_bubbles";
import { user_change_small } from "./data/user_change_small";
import { users_group } from "./data/user_group_small";
import { user_small } from "./data/user_small";
import { yammer_announcement } from "./data/yammer_announcement";
import { yammer_group } from "./data/yammer_group";
import { yammer_logo } from "./data/yammer_logo";
import { yammer_poll } from "./data/yammer_poll";
import { yammer_praise_ace } from "./data/yammer_praise_ace";
import { yammer_praise_checkeredflag } from "./data/yammer_praise_checkeredflag";
import { yammer_praise_coffee } from "./data/yammer_praise_coffee";
import { yammer_praise_diamond } from "./data/yammer_praise_diamond";
import { yammer_praise_doublerainbow } from "./data/yammer_praise_doublerainbow";
import { yammer_praise_gift } from "./data/yammer_praise_gift";
import { yammer_praise_glasses } from "./data/yammer_praise_glasses";
import { yammer_praise_graduationcap } from "./data/yammer_praise_graduationcap";
import { yammer_praise_heart } from "./data/yammer_praise_heart";
import { yammer_praise_lightbulb } from "./data/yammer_praise_lightbulb";
import { yammer_praise_money } from "./data/yammer_praise_money";
import { yammer_praise_monocle } from "./data/yammer_praise_monocle";
import { yammer_praise_ninja } from "./data/yammer_praise_ninja";
import { yammer_praise_pie } from "./data/yammer_praise_pie";
import { yammer_praise_star } from "./data/yammer_praise_star";
import { yammer_praise_thumbsup } from "./data/yammer_praise_thumbsup";
import { yammer_praise_trophy } from "./data/yammer_praise_trophy";
import { yammer_question } from "./data/yammer_question";
import styles from "./LeanIcon.module.scss";

export const Icons = {
  ArrowsUpAndDown: arrows_up_down_small,
  ArrowUp: arrow_up_small,
  ArrowDown: arrow_down_small,
  ArrowRight: arrow_right_small,
  ArrowLeft: arrow_left_small,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronSmallUp,
  ChevronSmallDown,
  ChevronSmallLeft,
  ChevronSmallRight,
  Circle,
  Cross: cross_104_small,
  Dot,
  HandSbb: hand_sbb_297_small,
  Pen: pen_16_small,
  SignExclamationPoint: sign_exclamation_point_1_small,
  Tick: tick_112_small,
  Gears: gears_small,
  LongRightArrowSmall: arrow_long_right_small,
  CircleInformationSmall: circle_information_small,
  CircleQuestionMarkSmall: circle_question_mark_small,
  CircleArrowSmall: arrows_circle_small,
  FaceSmiling: face_smiling_small,
  FaceSad: face_sad_small,
  Clock: clock_small,
  Trash: trash_8_small,
  YammerQuestion: yammer_question,
  YammerPoll: yammer_poll,
  YammerLogo: yammer_logo,
  YammerGroup: yammer_group,
  YammerAnnouncement: yammer_announcement,
  YammerPraiseCoffee: yammer_praise_coffee,
  YammerPraiseThumbsUp: yammer_praise_thumbsup,
  YammerPraiseAce: yammer_praise_ace,
  YammerPraiseCheckeredFlag: yammer_praise_checkeredflag,
  YammerPraiseDiamond: yammer_praise_diamond,
  YammerPraiseDoubleRainbow: yammer_praise_doublerainbow,
  YammerPraiseGift: yammer_praise_gift,
  YammerPraiseGlasses: yammer_praise_glasses,
  YammerPraiseGraduationCap: yammer_praise_graduationcap,
  YammerPraiseHeart: yammer_praise_heart,
  YammerPraiseLightBulb: yammer_praise_lightbulb,
  YammerPraiseMoney: yammer_praise_money,
  YammerPraiseMonocle: yammer_praise_monocle,
  YammerPraiseNinja: yammer_praise_ninja,
  YammerPraisePie: yammer_praise_pie,
  YammerPraiseStar: yammer_praise_star,
  YammerPraiseTrophy: yammer_praise_trophy,
  Information: information_small,
  SignExclamation: sign_exclamation_point_small,
  SpeechBubble: speech_bubble_small,
  SpeechBubbleGroupEmpty: speech_bubble_group_empty_small,
  Envelope: envelope_small,
  Telephone: telephone_receiver_small,
  MagnifyingGlass: magnifying_glass_small,
  HamburgerMenu: hamburger_menu_small,
  Browser: browser_small,
  User: user_small,
  UsersGroup: users_group,
  Network: network_small,
  Document: document_standard_small,
  Plus: plus_small,
  Drag: drag_small,
  SbbIcon: sbb_icon,
  SbbIconLogo: sbb_icon_logo,
  SbbIconIntranet: sbb_icon_intranet,
  Link: link,
  TwoSpeechingBubbles: two_speeching_bubbles,
  Star: star,
  OpenFolder: openfolder,
  FolderPlus: folderplus,
  DocumentCheck: documentcheck,
  DocumentAdd: documentadd,
  Globe: globe_small,
  ExternalLink: external_link,
  Home: house,
  List: list_small,
  FilterX: filter_x,
  Filter: filter,
  FilterSettings: filter_settings,
  Search: search,
  NineSquares: nine_squares_small,
  Exit: exit_small,
  Calendar: calendar_small,
  UserChange: user_change_small,
  Save: save,
  Eye: eye,
  PowerPoint: powerpoint,
  Paragraph: paragraph_small,
  BookSectionMark: book_section_mark_small,
  BookInfo: book_info,
};

export type IconName = keyof typeof Icons;

export interface ISbbIconStyle {
  iconColor?: string;
  iconBackground?: string;
  circleOutline?: string;
}

export interface ILeanIconOtherProps {
  icon: IconName;
  circled?: boolean;
  strokeWidth?: number;
  flipX?: boolean; // doesn't work in IE
  flipY?: boolean; // doesn't work in IE
  width?: string; // if specified, used as width of the enclosing div, can be percentage or measurement
  height?: string; // if specified, used as height of the enclosing div, can be percentage or measurement
  size?: string; // if specified, used as width / height of the enclosing div (if width / height is undefined)
}

export interface ILeanIconProps extends ISbbIconStyle, ILeanIconOtherProps {
  className?: string;
  innerClassName?: string;
  title?: string;
  onClick?: () => void;
}

function getFlipScale(flipX?: boolean, flipY?: boolean): string | undefined {
  if (flipX || flipY) {
    return `scale(${flipX ? "-1" : 1}, ${flipY ? "-1" : 1})`;
  }

  return undefined;
}

export const LeanIcon: React.FunctionComponent<ILeanIconProps> = ({
  icon,
  iconColor,
  strokeWidth,
  circled,
  circleOutline,
  iconBackground,
  flipX,
  flipY,
  size,
  height,
  width,
  title,
  className,
  innerClassName = "",
  onClick,
}) => {
  const Icon = Icons[icon];

  if (!Icon) {
    return null;
  }

  className = classNames(styles.sbbIcon, circled && styles.circled, onClick && styles.clickable, className);
  innerClassName = classNames(styles.icon, innerClassName);

  const flipScale = getFlipScale(flipX, flipY);
  const transform = flipScale ? { transform: flipScale } : {};
  const divBackground = !circled && iconBackground ? { style: { backgroundColor: iconBackground } } : {};

  const divStyle: React.CSSProperties = {};

  // computation of the container div. We try to compute a square div, unless
  // otherwise specified by the props.
  if (size) {
    divStyle.height = height || size;
    divStyle.width = height || size;
    divStyle.minWidth = height || size;
  } else {
    if (!height && !width) {
      divStyle.height = circled ? "34px" : "24px";
      divStyle.width = circled ? "34px" : "24px";
      divStyle.minWidth = circled ? "34px" : "24px";
    } else {
      divStyle.width = width;
      divStyle.minWidth = width;
      if (height) {
        divStyle.height = height;
      } else {
        divStyle.paddingBottom = width;
      }
    }
  }

  // The size of the circle (borders included), 33.6, is 140% * 24, the size of the icon itself
  return (
    <div
      className={className}
      {...divBackground}
      onClick={
        onClick
          ? (event) => {
              event.stopPropagation();
              onClick();
            }
          : undefined
      }
      style={divStyle}
      title={title}
    >
      {circled && (
        <svg xmlns="http://www.w3.org/2000/svg" className={styles.circle} viewBox="-16.8 -16.8 33.6 33.6">
          <circle
            cx="0"
            cy="0"
            r="15.8"
            stroke={circleOutline || iconColor || "currentColor"}
            strokeWidth="1"
            fill={iconBackground || "none"}
          />
        </svg>
      )}
      <Icon className={innerClassName} strokeWidth={strokeWidth} stroke={iconColor || "currentColor"} {...transform} />
    </div>
  );
};
